
import React, { useState } from "react";
import { isValidEmail } from "components/core/ManageUsers/userValidation";
import { useNavigate } from "react-router-dom";
import useOnboardingStore from "components/core/Onboarding/useOnboardingStore";
import { STATUS_BEGIN } from "utils/constants/others";
import { Button } from "../Common/styles.common";
import { GrnBottomModal } from "./styles.grn";
import {
  EmailSheetWrapper,
  EmailSheetTitleRow,
  EmailSheetTitle,
  EmailInputContainer,
  EmailInput,
  EmailHintText,
  EmailErrorText,
  EmailCtaWrapper,
  EmailDismissButton,
} from "./styles.email";
import Spinner from "sushiweb/Spinner/Spinner";

const NoEmailBottomSheet = ({
  isOpen,
  onClose,
  source,
  purchaseOrderId,
  grnId,
  formState,
}) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const requestSignupOtp = useOnboardingStore((state) => state.requestSignupOtp);
  const signupOtpStatus = useOnboardingStore((state) => state.signupOtpStatus);
  const loading = signupOtpStatus === STATUS_BEGIN;

  const handleVerifyClick = async () => {
    setError("");
    if (!isValidEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    const res = await requestSignupOtp("email", email.trim());
    if (!res.ok) {
      setError(res.message || "Failed to send OTP. Please try again.");
      return;
    }
    onClose();
    navigate("/user/verify-email", {
      state: {
        email: email.trim(),
        source,
        purchaseOrderId,
        grnId,
        formState,
      },
    });
  };

  return (
    <GrnBottomModal visible={isOpen} onClose={onClose}>
      <EmailSheetWrapper>

        {/* Title */}
        <EmailSheetTitleRow>
          <EmailSheetTitle>Enter your email address</EmailSheetTitle>
        </EmailSheetTitleRow>

        {/* Email input container */}
        <EmailInputContainer $hasError={!!error}>
          {/* Input box */}
          <EmailInput
            type="email"
            placeholder="Email address"
            value={email}
            $hasError={!!error}
            onChange={(e) => {
              setEmail(e.target.value);
              setError("");
            }}
            onKeyDown={(e) => e.key === "Enter" && handleVerifyClick()}
          />

          {/* Descriptive text inside container */}
          <EmailHintText>
            Please add your email address for Seller hub.<br />This email will also be used to send updates on the dispute raised.
          </EmailHintText>
        </EmailInputContainer>

        {/* Inline error */}
        {error ? <EmailErrorText>{error}</EmailErrorText> : null}

        {/* CTA */}
        <EmailCtaWrapper>
          <Button
            className="fs-14 text-white fw-600"
            style={{ marginBottom: "0px" }}
            onClick={handleVerifyClick}
            disabled={loading}
          >
            {loading ? <Spinner color="white" /> : "Verify OTP"}
          </Button>

          {/* Secondary dismiss */}
          <EmailDismissButton onClick={onClose}>Not now</EmailDismissButton>
        </EmailCtaWrapper>
      </EmailSheetWrapper>
    </GrnBottomModal>
  );
};

export default NoEmailBottomSheet;
